import { render, staticRenderFns } from "./McrFooter.vue?vue&type=template&id=c3b8bb6e"
import script from "./McrFooter.vue?vue&type=script&lang=js"
export * from "./McrFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports